import {
  IconBook2,
  IconCalendarEvent,
  IconCalendarUser,
  IconHeartHandshake,
  IconHome,
  IconMicrophone2,
  IconShoppingBag,
  IconUserCircle,
  IconUsersGroup,
} from "@tabler/icons-react";
import type { ModuleKey, PermissionKey } from "@how/types";
import type { AppFrameNavItem } from "@how/ui";

export interface GatedNavItem extends AppFrameNavItem {
  /** Shown only when authorize_check allows it; navigation is convenience, the server still decides. */
  readonly permission?: PermissionKey;
  /** Shown only when the module is usable in this church. */
  readonly module?: ModuleKey;
}

/** Kept free of side effects so tests can import it. */
export const NAV: readonly GatedNavItem[] = [
  { to: "/", label: "Home", icon: IconHome },
  { to: "/profile", label: "My profile", icon: IconUserCircle },
  { to: "/groups", label: "Groups", icon: IconUsersGroup, module: "groups" },
  { to: "/events", label: "Events", icon: IconCalendarEvent, module: "events" },
  // Sermons and media (ADR 0061): the church's published sermons to watch, hear and follow.
  { to: "/sermons", label: "Sermons", icon: IconMicrophone2, module: "sermons_media" },
  // Devotionals (ADR 0077): today's devotional and the earlier ones, to read.
  { to: "/devotionals", label: "Devotionals", icon: IconBook2, module: "devotionals" },
  // My schedule (ADR 0070): every church's dates in one place; the old Serving page.
  { to: "/my-schedule", label: "My schedule", icon: IconCalendarUser, module: "services" },
  { to: "/shop", label: "Shop", icon: IconShoppingBag, module: "commerce" },
  { to: "/care", label: "Care", icon: IconHeartHandshake },
];
